import { redtypes } from '../../types/redTypes';

export const redReducer = (state, action) => {
    switch (action.type) {
        case redtypes.loadZonas:
            return {
                ...state,
                zonas: [...action.payload],
            };
        case redtypes.loadAutos:
            return {
                ...state,
                autos: [...action.payload],
            };
        case redtypes.loadZones:
            return {
                ...state,
                zones: [...action.payload],
            };
        case redtypes.loadNaps:
            return {
                ...state,
                naps: [...action.payload],
            };
        case redtypes.loadFabri:
            return {
                ...state,
                fabricantes: [...action.payload],
            };
        case redtypes.loadMkts:
            return {
                ...state,
                mktiks: [...action.payload],
            };
        case redtypes.loadIpv4:
            return {
                ...state,
                ipv4: [...action.payload],
            };
        case redtypes.loadRoles:
            return {
                ...state,
                roles: [...action.payload],
            };
        case redtypes.loadEmisores:
            return {
                ...state,
                emisores: [...action.payload],
            };

        case redtypes.loadPlanes:
            return {
                ...state,
                internet: [...action.payload],
            };
        case redtypes.loadPlanesFi:
            return {
                ...state,
                planesfi: [...action.payload],
            };
        case redtypes.loadOlt:
            return {
                ...state,
                olts: [...action.payload],
            };
        case redtypes.loadPerzo:
            return {
                ...state,
                perzo: [...action.payload],
            };
       
        case redtypes.loadDash:
            return {
                ...state,
                dataDash: action.payload,
            };
        case redtypes.loadSpeed:
            return {
                ...state,
                dataSpeed: action.payload,
            };
        case redtypes.loadTags:
            return {
                ...state,
                tags: action.payload,
            };
        case redtypes.cerrarSesion:
            return {
                mktiks: [],
                ipv4: [],
                emisores: [],
                naps: [],
                internet: [],
                perzo: [],
                planActivo: {},
                fabricantes: [],
                zonas: [],
                roles: [],
               
                dataDash: null,
                dataSpeed: [],
                //! datos de fibra
                zones: [],
                olts: [],
                planesfi: [],
                tags: [],
            };
        default:
            return state;
    }
};
